// vc-persistent-cart.js
(function () {
  const LOG = false;
  const log = (...a) => LOG && console.log('[PersistentCart]', ...a);

  const BACKEND = window.VEDHACART_CONFIG.serverUrl;

  function isLoggedIn() {
    return !!window.VC_CUSTOMER_ID;
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  // Save current cart snapshot into metafield via backend
  async function saveCartSnapshot() {
    if (!isLoggedIn()) return;

    try {
      const cart = await fetchCart();
      if (!cart || !Array.isArray(cart.items)) return;

      await fetch(`${BACKEND}/cart/save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          customerId: window.VC_CUSTOMER_ID,
          items: cart.items,
        }),
      });

      log('Saved cart snapshot for customer', window.VC_CUSTOMER_ID);
    } catch (e) {
      console.warn('[PersistentCart] save failed', e);
    }
  }

  // Restore cart from metafield if current cart is empty
  async function restoreCartIfEmpty() {
    if (!isLoggedIn()) return;

    try {
      const cart = await fetchCart();
      if ((cart.item_count || 0) > 0) {
        log('Cart not empty, no restore needed');
        return;
      }

      const res = await fetch(
        `${BACKEND}/cart/load?customerId=${encodeURIComponent(
          window.VC_CUSTOMER_ID
        )}`,
        { credentials: 'same-origin' }
      );

      if (!res.ok) {
        log('No persisted cart to restore (HTTP ' + res.status + ')');
        return;
      }

      const saved = await res.json();
      if (!Array.isArray(saved) || !saved.length) {
        log('No items in persisted cart');
        return;
      }

      log('Restoring cart from persisted snapshot', saved);

      // Just in case, clear cart first (should already be empty)
      await fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
      });

      // Add each item back
      for (const it of saved) {
        const variantId = String(it.variantId || it.variant_id);
        const qty = String(it.quantity || it.qty || 1);

        const body = new URLSearchParams({
          id: variantId,
          quantity: qty,
        }).toString();

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/x-www-form-urlencoded; charset=UTF-8',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body,
        }).then((r) => r.json());
      }

      // Let existing listeners (cart drawer / header badge) refresh
      document.dispatchEvent(new Event('vc:cart:updated'));
    } catch (e) {
      console.warn('[PersistentCart] restore failed', e);
    }
  }

  // Whenever the cart changes, save a snapshot
  document.addEventListener('cart:updated', () => {
    if (!isLoggedIn()) return;
    saveCartSnapshot();
  });

  document.addEventListener('vc:cart:updated', () => {
    if (!isLoggedIn()) return;
    saveCartSnapshot();
  });

  // On first load as a logged-in customer, try to restore if empty
  document.addEventListener('DOMContentLoaded', () => {
    if (!isLoggedIn()) return;
    restoreCartIfEmpty();
  });
})();
